module.exports = __webpack_public_path__ + "img/syl_main2.6e4601bd.jpg";